import { render, staticRenderFns } from "./UploadFiles.vue?vue&type=template&id=d709f78a&scoped=true&"
import script from "./UploadFiles.vue?vue&type=script&lang=js&"
export * from "./UploadFiles.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d709f78a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/project/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d709f78a')) {
      api.createRecord('d709f78a', component.options)
    } else {
      api.reload('d709f78a', component.options)
    }
    module.hot.accept("./UploadFiles.vue?vue&type=template&id=d709f78a&scoped=true&", function () {
      api.rerender('d709f78a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/application/components/Application/Setup/UploadFiles.vue"
export default component.exports